import(/* webpackMode: "eager" */ "/opt/build/repo/app/kittens/application/page.tsx")